import { Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { IoTrashBinOutline } from "react-icons/io5";
import uuid from "react-uuid";
import FetchContext from "../../../../contexts/fetch";
import FlowContext from "../../../../contexts/flowContext";
import NotificationContext from "../../../../contexts/notification";
import UserContext from "../../../../contexts/user";
import useConfirmation from "../../../../hooks/useConfirmation";
import styles from "../controls.module.css";

const RemoveFlow = () => {
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [, notificationDispatcher] = useContext(NotificationContext);
  const [fetchState, fetchDispatcher] = useContext(FetchContext);
  const [userState] = useContext(UserContext);

  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (flowState._id) {
      setShouldRender(true);
    } else {
      setShouldRender(false);
    }
  }, [flowState._id]);

  const onDelete = function () {
    fetchDispatcher({
      type: "fetch-delete-flow",
      flowId: flowState._id,
      brand: userState.currentBrand,
      app: userState.currentApp,
      onSuccess: (msg) => {
        notificationDispatcher({
          type: "notify",
          notification: {
            id: uuid(),
            type: "success",
            message: msg,
            duration: 3000,
          },
        });
        flowDispatcher({
          type: "clear-flow",
        });
        fetchDispatcher({
          type: "fetch-flow-list",
          app: userState.currentApp,
        });
      },
      onError: (msg) => {
        notificationDispatcher({
          type: "notify",
          notification: {
            id: uuid(),
            type: "failure",
            message: msg,
            duration: 3000,
          },
        });
      },
    });
  };

  const deleteWithConfirmation = useConfirmation(
    {
      title: "Confirmer la suppression",
      message: "La suppression du flow est irréversible. Continuer ?",
      onOk: onDelete,
    },
    fetchState.loadingDeleteFlowApi
  );

  const handleDeleteButtonClick = function () {
    deleteWithConfirmation();
  };

  return (
    shouldRender && (
      <div
        className={styles.button_container}
        onClick={handleDeleteButtonClick}
      >
        <Tooltip placement="bottom" title={"Delete"}>
          <span className={styles.icon_container}>
            <IoTrashBinOutline className={styles.remove_button} />
          </span>
        </Tooltip>
      </div>
    )
  );
};

export default RemoveFlow;
